import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { logout } from 'helpers/utils';

const routesConfig = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    messageId: 'Dashboard',
    type: 'item',
    url: '/dashboard',
  },
  {
    id: 'business-management',
    title: 'Business Management',
    messageId: 'Business Management',
    type: 'item',
    url: '/business-management',
  },
  {
    id: 'analytics',
    title: 'Analytics',
    messageId: 'Analytics',
    type: 'collapse',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        messageId: 'Dashboard',
        type: 'item',
        url: '/analytics/dashboard',
      },
      {
        id: 'revenue',
        title: 'Revenue',
        messageId: 'Revenue',
        type: 'item',
        url: '/analytics/revenue',
      },
      {
        id: 'active-user',
        title: 'Active User',
        messageId: 'Active User',
        type: 'item',
        url: '/analytics/active-user',
      },
      {
        id: 'coupon-redemptions',
        title: 'Coupon Redemptions',
        messageId: 'Coupon Redemptions',
        type: 'item',
        url: '/analytics/coupon-redemptions',
      },
    ],
  },
  {
    id: 'stamp-card',
    title: 'Stamp Card',
    messageId: 'Stamp Card',
    type: 'item',
    url: '/stamp-card',
  },
  {
    id: 'customer',
    title: 'Customer',
    messageId: 'Customer',
    type: 'item',
    url: '/customer',
  },
  {
    id: 'config',
    title: 'Config',
    messageId: 'Config',
    type: 'collapse',
    children: [
      {
        id: 'business-type',
        title: 'Business Types',
        messageId: 'Business Types',
        type: 'item',
        url: '/config/business-type',
      },
      {
        id: 'product-type',
        title: 'Product Types',
        messageId: 'Product Types',
        type: 'item',
        url: '/config/product-type',
      },
    ],
  },
  {
    id: 'terms-and-conditions',
    title: 'Terms and Conditions',
    messageId: 'Terms and Conditions',
    type: 'item',
    url: '/terms-and-conditions',
  },
  {
    id: 'privacy-policy',
    title: 'Privacy Policy',
    messageId: 'Privacy Policy',
    type: 'item',
    url: '/privacy-policy',
  },
  {
    id: 'logout',
    title: 'Logout',
    messageId: 'Logout',
    type: 'logout-action',
    onClick: () => {
      logout();
      window.location.href = '/login';
    },
    icon: <LogoutOutlinedIcon />,
    className: 'logout-nav-item',
  },
];
export default routesConfig;
